export default {
    'duration-of-visit-in-minutes': 'Duration of visit in minutes',
    'distributed-samples': 'Distributed samples',
    'unavailable-products': 'Unavailable products'
}